import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
  isSaving?: boolean;
};

export const UnsavedChangesDialog = ({ open, onClose, onDiscard, onSave, isSaving = false }: Props) => {
  const { t } = useTranslation();

  // Modal stacking layers:
  //   1300: default MUI Dialog (e.g., MobileJobDetailSheet)
  //   1301: BottomSheet (mobile editor sheets that open over the detail Dialog)
  //   1302: UnsavedChangesDialog (sits above any BottomSheet for discard-confirm)
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}>
      <DialogTitle>{t('common.unsavedChanges', 'Unsaved Changes')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('common.unsavedChangesMessage', 'You have unsaved changes that will be lost if you leave without saving.')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={isSaving}>
          {t('common.continueEditing', 'Continue Editing')}
        </Button>
        <Button onClick={onDiscard} variant="outlined" color="error" disabled={isSaving}>
          {t('common.discardChanges', 'Discard Changes')}
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          color="primary"
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isSaving ? t('common.saving', 'Saving...') : t('common.saveAndClose', 'Save Changes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
